import dayjs from 'dayjs'

const ONE_DAY_IN_SECONDS = 24 * 60 * 60

type CacheItem<T = any> = {
  data: T
  expiresIn: string
}

/**
 *
 * @param cacheKey - The key to be used to store the data
 * @param data - The data to be stored
 * @param env - The environment to store the data
 * @param ttl - The time to live of the data (Seconds)
 */
export async function save<T = any>(
  cacheKey: string,
  data: T,
  env: 'localStorage' | 'sessionStorage' = 'sessionStorage',
  ttl = ONE_DAY_IN_SECONDS,
) {
  const payload = JSON.stringify({
    data,
    expiresIn: dayjs().add(ttl, 'seconds').toISOString(),
  })

  if (env === 'localStorage') {
    await localStorage.setItem(cacheKey, payload)
  } else {
    await sessionStorage.setItem(cacheKey, payload)
  }
}

export async function get<T = any>(
  cacheKey: string,
  env: 'localStorage' | 'sessionStorage' = 'sessionStorage',
) {
  const isExpired = (item: CacheItem): boolean => {
    console.log(dayjs(dayjs()).isAfter(item.expiresIn))
    return dayjs(dayjs()).isAfter(item.expiresIn)
  }

  if (env === 'sessionStorage') {
    const stored = await sessionStorage.getItem(cacheKey)

    if (!stored) {
      return undefined
    }

    const cacheItem = JSON.parse(stored) as CacheItem<T>

    if (isExpired(cacheItem)) {
      sessionStorage.removeItem(cacheKey)
      return undefined
    }

    return cacheItem.data
  } else {
    const stored = await localStorage.getItem(cacheKey)

    if (!stored) {
      return undefined
    }

    const cacheItem = JSON.parse(stored) as CacheItem<T>

    if (isExpired(cacheItem)) {
      localStorage.removeItem(cacheKey)
      return undefined
    }

    return cacheItem.data
  }
}

export async function remove(
  cacheKey: string,
  env: 'localStorage' | 'sessionStorage' = 'sessionStorage',
) {
  env === 'localStorage'
    ? localStorage.removeItem(cacheKey)
    : sessionStorage.removeItem(cacheKey)
}
